import {ZIDXFormField} from "./FormField.js";

export class ZIDXFormConfig {
    action="";
    cancelURL="";
    submitLabel="Save";
    enableRecaptcha=false;
    disableButtons=false;
    redirectOnSaveURL="";
    formFields:ZIDXFormField[]=[];
}